import { render, staticRenderFns } from "./GuestSelectWidget.vue?vue&type=template&id=5fb5bc8a&scoped=true&"
import script from "./GuestSelectWidget.vue?vue&type=script&lang=js&"
export * from "./GuestSelectWidget.vue?vue&type=script&lang=js&"
import style0 from "./GuestSelectWidget.vue?vue&type=style&index=0&id=5fb5bc8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb5bc8a",
  null
  
)

export default component.exports